<template>
  <!-- 个人信息 -->
  <div class="nom-info">
    <el-form
      class="mt8"
      label-width="120px"
      label-position="left"
      :show-message="false"
      @submit.native.prevent
      :model="form"
      :rules="rules"
      ref="form"
      
    >
      <el-form-item label="头像">
        <img-upload ref="upload"  :src="form.face" @changeFace="changeFace"></img-upload>
      </el-form-item> 

      <el-form-item label="昵称：" required>
        <el-input v-model.trim="form.taobao_nickname" placeholder="请输入昵称"></el-input>
      </el-form-item>

      <el-form-item label="性别：">
        <el-radio-group v-model="form.sex">
          <el-radio :label="'1'">男</el-radio>
          <el-radio :label="'2'">女</el-radio>
          <el-radio :label="'0'">保密</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="生日：" required>
        <el-date-picker
         v-model="form.birthday"
          type="date" 
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
        />
      </el-form-item>

      <el-form-item label="所在地：">
        <el-cascader expand-trigger="click" :options="formSrc.location" v-model="form.location" @active-item-change="handleItemChange" :props="props"></el-cascader>
      </el-form-item>

      <el-form-item label="联系QQ：" prop="qq">
        <el-input type="number" step="1" v-model.trim="form.qq" placeholder="请输入联系QQ"></el-input>
        <p class="help">请谨慎填写，QQ号将出现在你的淘客个人主页，让别人与你取得联系</p>
      </el-form-item>

      <el-form-item label="邮箱：" required>
        <el-input v-model.trim="form.email" placeholder="请输入邮箱"></el-input>
      </el-form-item>

      <el-form-item label="工作类型：" required>
        <el-radio-group v-model="form.job">
          <el-radio :label="'公司'">公司</el-radio>
          <el-radio :label="'工作室/团队/其他组织'">工作室/团队/其他组织</el-radio>
          <el-radio :label="'自由职业'">自由职业</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="团队名称：">
        <el-input v-model.trim="form.company" placeholder="请输入完整公司名称"></el-input>
      </el-form-item>

      <el-form-item label="部门或职位：">
        <el-input v-model.trim="form.job_title" placeholder="请输入部门或职位"></el-input>
      </el-form-item>

      <el-form-item label="工作性质：" required>
        <el-radio-group v-model="form.work_type">
          <el-radio :label="'兼职'">兼职</el-radio>
          <el-radio :label="'全职'">全职</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="推广方式：">
        <el-checkbox-group v-model="form.sale_type">
          <el-checkbox label="QQ群">QQ群</el-checkbox>
          <el-checkbox label="微信">微信</el-checkbox>
          <el-checkbox label="微博">微博</el-checkbox>
          <el-checkbox label="网站">网站</el-checkbox>
          <el-checkbox label="APP">APP</el-checkbox>
          <el-checkbox label="线下推广">线下推广</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="推广收益：">
        <el-select v-model="form.income_type" placeholder="请选择">
          <el-option
            v-for="item in formSrc.income_type"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <div class="border1 mb12"></div>

      <zt-button type="primary"  @click="onSubmit"  size="medium">确认并保存</zt-button>
    </el-form>
  </div>
</template>

<script>
import store from '@/store'
import imgUpload from '@cps/Upload/imgUpload'
import { limitObject, emtry2null } from '@/utils'
import { myinfo_edit, area } from '@/api/myCenter'
export default {
  name: 'myCenterNomInfo',
  components:{
    imgUpload,
    // Upload
  },
  data: () => ({
    src:[],
    form: {
      face:'', //头像
      taobao_nickname:'', //昵称
      sex: null, // 性别:  0保密 1男 2女
      birthday: null, // 生日
      location: [], // 所在地
      province: null, // 省
      city: null, // 市
      qq: null, // QQ
      email: null,
      job: null, // 工作类型
      company: null, // 单位名称
      job_title: null, // 部门或职位
      work_type: null, // 工作性质
      sale_type: [],  // 推广方式
      income_type: null, // 推广收益
    },
    rules: {
    },
    formSrc: {
      location: [],

      
      income_type: [
        {
          label: '1000以下',
          value: '1000以下',
        }, {
          label: '1000-5000',
          value: '1000-5000',
        }, {
          label: '5000-1w',
          value: '5000-1w',
        }, {
          label: '1w-5w',
          value: '1w-5w',
        }, {
          label: '5w-10w',
          value: '5w-10w',
        }, {
          label: '10w以上',
          value: '10w以上',
        },
      ],

      
    },

    province: [],      // 省份
    props: {
      value: 'name',
      label: 'name',
    },
  }),
  created() {
    this.getUserInfo();
  },
  methods: {
    //改变头像
    changeFace(filePath) {
      this.form.face = filePath
    },
    // 获取 - 个人信息
    getUserInfo() {
      store.dispatch('GetUserInfo').then((data) => {
        var info = limitObject(data, Object.keys(this.form), true);
        info.location = [info.province, info.city];
        // info.location = ['', '']
        info.sale_type = info.sale_type ? info.sale_type.split(',') : [];
        this.form = info;
        this.form.face = info.face==null?'https://img.zhutui.cn/20190731/15645381561623.png':info.face
        console.log('获取个人信息', info);
        this.getArea()
      })
    },
    
    onSubmit() {
      var info = {...this.form}
      // 数据转换
      let [province, city] = info.location;
      info.province = province;
      info.city = city;
      info.sale_type = info.sale_type.join(',') || null;
      // 数据清洁
      info = limitObject(info, [
        'location',
      ]);
      info = emtry2null(info)
      console.log('提交个人信息', info);
      // 提交
      myinfo_edit(info).then(({data}) => {
        var {error_code, error_message} = data;
        if (error_code === 0) {
          this.$message({
            type: 'success',
            message: '提交成功',
          })
          this.getUserInfo()
          this.$emit('change', true)
        }else{
          this.$message({
            type: 'error',
            message: error_message,
          })
        }
      })
    },

    cleanForm(obj) {
      var temp = {...obj};
      Object.keys(temp).forEach((key) => {
        // 清除非真
        if(!temp[key]) {
          delete temp[key]
        }
      })
      return temp
    },

    // 获取地区列表
    getArea() {
      // 请求省份
      let requestSF = new Promise((res) => {
        area({ 'atype': 1 }).then(({data}) => {
          if(this.$requestResultMessage(data)) {
            let sf = data.list.map((item) => { 
              // 香港,澳门屏蔽二级选项
              let HKMacau = ['香港', '澳门'];
              let isHKMacau = HKMacau.includes(item.name);
              return { 
                ...item,
                children: isHKMacau ? null : [],
              } 
            })
            res(sf);
          }
        })
      })
      // 请求直辖市
      let requestZXS = new Promise((res) => {
        area({ 'atype': 2 }).then(({data}) => {
          if(this.$requestResultMessage(data)) {
            let zxs = data.list.map((item) => { return { ...item, children: null } })
            res(zxs);
          }
        })
      })
      // 请求一级地区
      Promise.all([requestSF, requestZXS]).then((res) => {
        let [sf, zxs] = res;
        this.formSrc.location = zxs.concat(sf);
      }).then(() => {
        let [first, second] = this.form.location
        if(second) {
          this.handleItemChange([first])
        }
      })
    },

    handleItemChange(names) {
      var id = this.formSrc.location.find((item) => item.name === names[0]).id
      // 请求 地级市
      if(id) {
        area({ 
          'atype': 3,
          'parent_id': id,
        }).then(({data}) => {
          if(this.$requestResultMessage(data)) {
            var prev = this.formSrc.location.find((item) => item.id == id)
            if(data.list.length) {
              prev.children = data.list
            }else{
              prev.children = null;
            }
            
          }
        })
      }
      
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/styles/form.scss";
.border1 {
  border-top: 1px solid $theme-border3;
}
.help {
  font-size: 12px;
  color: $theme-textplaceholder;
}
</style>